import React from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import BaseAreaChart from "../reports/BaseAreaChart";
import BaseBarChart from "../reports/BaseBarChart";

import OasisPoolNav from './OasisPoolNav';
import OasisPoolHeader from './OasisPoolHeader';
import ApiUtils from '../util/ApiUtils';
import SPUtilities from '../util/SPUtilities';
import RespUtils from '../util/RespUtils';
import Utilities from '../util/Utilities';
import UINotes from "../util/UINotes";
import ChartUtils from "../util/ChartUtils";
import OasisUtils from "./OasisUtils";
import UIUtils from "../util/UIUtils";

class PoolStats extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pool: {},
      data: [],
      width: window.innerWidth,
      size: 10,
      responsive: true,
    }
    this.updateDimensions = this.updateDimensions.bind(this);
    // this.reload = this.reload.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);

    const allData = await ApiUtils.get(SPUtilities.getPoolUrl(this, "listData?type=poolStats"));
    // console.log("allData is:", allData);

    if (allData) {
      let pool = allData["pool"];
      this.setState({"pool": pool, "data": allData["data"], isLoading: false});
    }
  }

  render() {
    if (this.state.isLoading) {
      return <div>Loading</div>;
    }

    var columns = [
      {text: "Date", dataField: "title", sort: true, headerStyle: Utilities.width(25)},
      {text: "Total Stake", dataField: "totalStake", formatter: SPUtilities.stakeFormatterBySize, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
      {text: "Total Shares", dataField: "totalShares", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
      {text: "Delegates", dataField: "uniqueDelegates", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
    ];
    // {text: "Self Bond", dataField: "selfBond", formatter: SPUtilities.stakeFormatterBySize, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},

    if (RespUtils.isNotMobileView()) {
      columns.push({text: "In Consensus", dataField: "selectedInd", sort: true, headerStyle: Utilities.width(15)});
    }

    // var otherStatsColumns;
    // if (window.innerWidth < 600) {
    //   otherStatsColumns = [
    //     {text: "Epoch",dataField: "title", sort: true, headerStyle: Utilities.width(15)},
    //     {text: "Keys", dataField: "blsKeyCount", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
    //     {text: "Delegates", dataField: "uniqueDelegates", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(25)},
    //     {text: "Stake (millions)", dataField: "totalStaked", formatter: SPUtilities.stakeFormatterRounded, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(25)},
    //     {text: "Elected", dataField: "elected", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
    //   ];
    // } else {
    //   otherStatsColumns = [
    //     {text: "Epoch",dataField: "title", sort: true, headerStyle: Utilities.width(15)},
    //     {text: "BLS Keys", dataField: "blsKeyCount", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
    //     {text: "Delegates", dataField: "uniqueDelegates", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
    //     {text: "Self Stake", dataField: "selfStake", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
    //     {text: "Stake", dataField: "totalStaked", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
    //     {text: "Bid", dataField: "bidPerSeat", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
    //     {text: "Fee", dataField: "fee", formatter: OasisUtils.convertPercentFormatter, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
    //     {text: "Elected", dataField: "elected", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
    //   ];
    // }

    const options = UIUtils.getPageOptionsSmall(this, 10);

    const defaultSorted = [{
      dataField: 'title', // if dataField is not match to any column you defined, it will be ignored.
      order: 'desc' // desc or asc
    }];

    return (
      <div>
        <p/>
        <OasisPoolHeader pool={this.state.pool} notification={this.state.notification} title="Validator Stats"/>

        <hr/>
        <BaseAreaChart title="Stake History" xAxis="Date" yAxis="Total Stake"
          showVerticalLabel={false} valueAttr="totalStake"
          data={this.state.data} />

        <hr/>
        <BaseBarChart title="Delegate History" xAxis="Date/Hour" yAxis="# of Delegates"
          showVerticalLabel={true} valueAttr="uniqueDelegates" showTotalLabel={false}
          data={this.state.data} xAxisValueAttr="title" />

        <hr/>
        <p/><p><b>Daily Stats</b></p>
        <BootstrapTable keyField='syncTime' data={ this.state.data }
          columns={ columns } striped options={options} defaultSorted={defaultSorted}
          condensed noDataIndication="Table is Empty/Loading"/>

        <OasisPoolNav poolId={this.state.pool.poolId}/>
      </div>
    );
  }
/*
<hr/>
{ChartUtils.render2Lines(this, "Expected Returns Index (ERI) by Epoch", this.state.data,
  "Epoch", "Expected Returns", "eri", "average", "eri")}
<hr/>
{ChartUtils.render2Lines(this, "Expected Returns (ER) by Epoch", this.state.data,
  "Epoch", "Expected Returns", "er", "netEr", "er")}


<hr/>
<p/><p><b>Other Stats</b></p>
<BootstrapTable keyField='epoch' data={ this.state.data }
columns={ otherStatsColumns } striped options={options} defaultSorted={defaultSorted}
condensed noDataIndication="Table is Empty/Loading"
/>
*/
}

export default PoolStats;



// WEBPACK FOOTER //
// ./src/oasis/PoolStats.js